import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

/**
 * Back-to-top button: fixed bottom right, appears once the visitor scrolls
 * past the hero (~700px), disappears at the top. Works on mobile and desktop.
 */
export default function BackToTop({ threshold = 700 }) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const onScroll = () => setShown(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return (
    <button
      type="button"
      data-testid="back-to-top"
      aria-label="Back to top"
      aria-hidden={!shown}
      tabIndex={shown ? 0 : -1}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={`fixed bottom-5 right-5 z-40 inline-flex items-center justify-center w-11 h-11 border border-ink bg-white text-ink shadow-[4px_4px_0px_0px_rgba(10,34,64,0.25)] hover:bg-ink hover:text-white transition-all duration-300 print:hidden ${
        shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <ArrowUp size={18} strokeWidth={1.75} />
    </button>
  );
}
